const $ = jQuery.noConflict();

class GoogleMap {
    constructor(map) {
       this.map = map
    }
    init() {

        $(this.map).each((index, el) =>{
            
            const map = this.newMap( $(el) );
        });
      

    }
    newMap($el) {

        const $markers = $el.find('.marker');
		const args = {
			zoom		: 16,
			center		: new google.maps.LatLng(0, 0),
			mapTypeId	: google.maps.MapTypeId.ROADMAP,
			disableDefaultUI: true
		};
		
		// create map	        	
		const map = new google.maps.Map( $el[0], args);
		
		// add a markers reference
		map.markers = [];
		
		// add markers
		$markers.each((index, marker) => {
			
		   	this.add_marker( $(marker), map );
			
		});
		
		// center map
		this.center_map( map );
		
		// return
		return map;	
    }

    //This function will add a marker to the selected Google Map
    add_marker( $marker, map ) {

        const latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );
    
        // create marker
        const marker = new google.maps.Marker({
            position	: latlng,
            map			: map
        });
    
        // add to array
        map.markers.push( marker );
    
        // if marker contains HTML, add it to an infoWindow
        if( $marker.html() )
        {
            // create info window
            var infowindow = new google.maps.InfoWindow({
                content		: $marker.html()
            });
    
            // show info window when marker is clicked
            google.maps.event.addListener(marker, 'click', () => {
                infowindow.open( map, marker );
            });
        }
    
    }

    //This function will center the map, showing all markers attached to this map
    center_map( map ) {

        // vars
        const bounds = new google.maps.LatLngBounds();
    
        // loop through all markers and create bounds
        $.each( map.markers, ( index, marker ) => {
            var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );
            bounds.extend( latlng );
        });
    
        // only 1 marker?
        if( map.markers.length == 1 )
        {
            // set center of map
            map.setCenter( bounds.getCenter() );
            map.setZoom( 7 );
        }
        else
        {
            // fit to bounds
            map.fitBounds( bounds );
        }
    
    }
    
}
const embedGoogleMap = new GoogleMap('.acf-map');

export default embedGoogleMap;



